<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="inspectionScheduleEquipmentResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      withCustomRowActions import-enabled
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="edit"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   showName
                                                   customLabel="计划详情"
                                                   @click="goToPlanDetail(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2020-11-12 10:49:22

    import emCommonListMixin from "@/mixin/em/common/list";
    import commonViewsUtil from "@/utils/commonViewsUtil";

    export default {
        name: "inspectionScheduleEquipmentListView",
        mixins: [emCommonListMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods:{
            goToPlanDetail(entity) {
                commonViewsUtil.gotoHolderList(this, "inspectionScheduleDetail",
                    {
                        inspectionScheduleIdFilter: entity.inspectionScheduleId,
                        emArchBasicDataCodeFilter: entity.emArchBasicDataCode
                    },
                    {
                        inspectionScheduleId: entity.inspectionScheduleId,
                        emArchBasicDataCode: entity.emArchBasicDataCode
                    },{export:'1',import:'1'})
            }
        }
    };
</script>